/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(9);


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	    //////////////////////
	    ///// INDEX    ///////
	    //////////////////////
	
	    $("select#landingLanguageSelect").change(function () {
	        window.localStorage.setItem("selectedLanguage", this.options[this.selectedIndex].value);
	        // console.log("Languge Selected: " + window.localStorage.getItem("selectedLanguage"))
	        window.localStorage.removeItem("current_user");
	        window.location = "/country";
	    });
	
	    $("input#landingLanguageSubmit").click(function () {
	        const langSelect = $("select#landingLanguageSelect")[0];
	        window.localStorage.setItem("selectedLanguage", langSelect.options[langSelect.selectedIndex].value);
	        window.location = "/country";
	    });
	
	    $("ul#flagStrip").children(".lang-item").each(function () {
	        $(this).click(function () {
	            window.localStorage.setItem("selectedLanguage", $(this).data("value"));
	            window.location = "/country";
	        })
	    });
	
	    //////////////////////
	    ///// COUNTRY    /////
	    //////////////////////
	
	    $("section#country-list").children(".country-item").each(function () {
	        $(this).click(function () {
	            const id = JSON.parse(window.localStorage.getItem("current_user")) ?
	                JSON.parse(window.localStorage.getItem("current_user"))["id"] :
	                null;
	            var code = $(this).data("countryCode");
	            if (typeof (code) === "number") {
	                code = code.toString();
	            }
	            if (id) {
	                var payload = {};
	                payload["first_country"] = code;
	                console.log(payload)
	                window.rest.put(
	                    'users/' + id,
	                    payload
	                ).then(function (user) {
	                    window.localStorage.setItem("current_user", JSON.stringify(user));
	                    window.location = "/profile";
	                })
	                .catch(function(e) {
	                    window.localStorage.setItem("selectedCountry", payload["first_country"]);
	                    window.location = "/register";
	                })
	            } else {
	                window.localStorage.setItem("selectedCountry", $(this).data("countryCode"));
	                window.location = "/register";
	            }
	        })
	    });
	
	    //////////////////////
	    ///// REGISTER    ////
	    //////////////////////
	
	    $("form#registerSocialForm").find('a#facebook-connect').click(function (e) {
	        window.amplitude ? window.amplitude.getInstance().logEvent('ClickRegister', {page:'register',provider:'facebook', branch: window.rest.environment.branch}):'';
	        var country = window.localStorage.getItem("selectedCountry");
	        var llanguage = +window.localStorage.getItem("selectedLanguage");
	        var url = "";
	        var base_url = window.rest.defaults.baseURL + "/auth/login-facebook";
	
	        if (country && llanguage) {
	            url = base_url + "?first_country=" + country + "&first_llanguage=" + llanguage;
	        } else if (country) {
	            url = base_url + "?first_country=" + country;
	        } else if (llanguage) {
	            url = base_url + "?first_llanguage=" + llanguage;
	        } else {
	            url = base_url;
	        }
	
	        window.location = url;
	    });
	
	    $("form#registerSocialForm").find('a#google-connect').click(function (e) {
	        window.amplitude ? window.amplitude.getInstance().logEvent('ClickRegister', {page:'register',provider:'google', branch: window.rest.environment.branch}):'';
	        var country = window.localStorage.getItem("selectedCountry");
	        var llanguage = +window.localStorage.getItem("selectedLanguage");
	        var url = "";
	        var base_url = window.rest.defaults.baseURL + "/auth/login-google";
	
	        if (country && llanguage) {
	            url = base_url + "?first_country=" + country + "&first_llanguage=" + llanguage;
	        } else if (country) {
	            url = base_url + "?first_country=" + country;
	        } else if (llanguage) {
	            url = base_url + "?first_llanguage=" + llanguage;
	        } else {
	            url = base_url;
	        }
	
	        window.location = url;
	    });
	
	    $("form#registerEmailForm").submit(function (e) {
	        window.amplitude ? window.amplitude.getInstance().logEvent('ClickRegister', {page:'register',provider:'email', branch: window.rest.environment.branch}):'';
	        e.preventDefault();
	        $(e.target).find('input#email').css({
	            'border': 'solid 2px #217093',
	            'color': '#217093'
	        });
	        $(e.target).find('p#hint').html("");
	
	        var payload = {
	            email: $(this).find('input#email').val()
	        }
	
	        window.localStorage.getItem("selectedLanguage") ? payload["first_llanguage"] = +window.localStorage.getItem("selectedLanguage") : "";
	        window.localStorage.getItem("selectedCountry") ? payload["first_country"] = window.localStorage.getItem("selectedCountry") : "";
	
	        window.rest.post('users', payload)
	            .then(function (response) {
	                window.location = "/verify";
	                window.localStorage.removeItem("current_user");
	            })
	            .catch(function (error) {
	                $(e.target).find('input#email').css({
	                    'border': 'solid 2px #e7040f',
	                    'color': '#e7040f'
	                });
	                $(e.target).find('p#hint').html('This email is either not real, not valid, or already registered.');
	            });
	    })
	
	    //////////////////////
	    ///// LOGIN    ///////
	    //////////////////////
	
	    $("form#loginSocialForm").find('a#facebook-connect').click(function (e) {
	        window.amplitude ? window.amplitude.getInstance().logEvent('ClickLogin', {page:'login',provider:'facebook', branch: window.rest.environment.branch}):'';
	        var country = window.localStorage.getItem("selectedCountry");
	        var llanguage = +window.localStorage.getItem("selectedLanguage");
	        var url = window.rest.defaults.baseURL + "/auth/login-facebook";
	        
	        window.location = url;
	    });
	
	    $("form#loginSocialForm").find('a#google-connect').click(function (e) {
	        window.amplitude ? window.amplitude.getInstance().logEvent('ClickLogin', {page:'login',provider:'google', branch: window.rest.environment.branch}):'';
	        var country = window.localStorage.getItem("selectedCountry");
	        var llanguage = +window.localStorage.getItem("selectedLanguage");
	        var url = window.rest.defaults.baseURL + "/auth/login-google";
	
	        window.location = url;
	    });
	
	    $("form#loginEmailForm").submit(function (e) {
	        window.amplitude ? window.amplitude.getInstance().logEvent('ClickLogin', {page:'login',provider:'email', branch: window.rest.environment.branch}):'';
	        e.preventDefault();
	        $(e.target).find('p#hint_email').html("");
	        $(e.target).find('p#hint_password').html("");
	        $(e.target).find('input#email').css({
	            'border': 'solid 2px #217093',
	            'color': '#217093'
	        });
	        $(e.target).find('input#password').css({
	            'border': 'solid 2px #217093;',
	            'color': '#217093'
	        });
	
	        window.rest.post('auth/login-email', {
	                email: $(this).find('input#email').val(),
	                password: $(this).find('input#password').val(),
	            })
	            .then(function (response) {
	                return window.localStorage.setItem("access_token", response.access_token);
	            })
	            .then(function () {
	                return window.rest.get("auth/current");
	            })
	            .then(function (response) {
	                window.localStorage.setItem("cached_user", JSON.stringify(response));
	                return response.id;
	            })
	            .then(function (response) {
	                // window.location = "/profile?id=" + response;
	                // window.location = "/profile";
	                window.location = "/dashboard";
	                // window.location = "/teachers";
	            })
	            .catch(function (error) {
	                if (error.message === "Invalid Password") {
	                    $(e.target).find('input#password').css({
	                        'border': 'solid 2px #e7040f',
	                        'color': '#e7040f'
	                    });
	                    $(e.target).find('p#hint_password').html(error.message);
	                } else if (error.message === "Your password is not set because you logged in with social media") {
	                    $(e.target).find('input#email').css({
	                        'border': 'solid 2px #e7040f',
	                        'color': '#e7040f'
	                    });
	                    $(e.target).find('p#hint_email').html(error.message + ', <strong><a class="dark-red" href="/reset">click here to set your password</a></strong>');
	                } else {
	                    $(e.target).find('input#email').css({
	                        'border': 'solid 2px #e7040f',
	                        'color': '#e7040f'
	                    });
	                    $(e.target).find('p#hint_email').html('Email is either not valid, or not registered, <strong><a class="dark-red" href="/register">click here to create a new account</a></strong>.');
	                }
	            });
	    })
	
	    //////////////////////
	    //RESEND VERIFICATION/
	    //////////////////////
	
	    $("form#resendEmailForm").submit(function (e) {
	        e.preventDefault();
	        $(e.target).find('input#email').css({
	            'border': 'solid 2px #217093',
	            'color': '#217093'
	        });
	        $(e.target).find('p#hint').html("");
	        window.rest.post('auth/resend-verification-email', {
	                email: $(this).find('input#email').val()
	            })
	            .then(function (response) {
	                window.location = "/verify";
	            })
	            .catch(function (error) {
	                $(e.target).find('input#email').css({
	                    'border': 'solid 2px #e7040f',
	                    'color': '#e7040f'
	                });
	                $(e.target).find('p#hint').html(error.message);
	            });
	    })
	
	    //////////////////////
	    //CHANGE EMAIL////
	    //////////////////////
	
	    $("form#changeEmailForm").submit(function (e) {
	        e.preventDefault();
	        $(e.target).find('input#email').css({
	            'border': 'solid 2px #217093',
	            'color': '#217093'
	        });
	        $(e.target).find('p#hint').html("");
	        window.rest.post('auth/reset-email', {
	                email: $(this).find('input#email').val()
	            })
	            .then(function (response) {
	                window.location = "/change";
	            })
	            .catch(function (error) {
	                $(e.target).find('input#email').css({
	                    'border': 'solid 2px #e7040f',
	                    'color': '#e7040f'
	                });
	                $(e.target).find('p#hint').html(error.message);
	            });
	    })
	
	    //////////////////////
	    /// RESET PASSWORD ///
	    //////////////////////
	
	    $("form#resetPasswordForm").submit(function (e) {
	        e.preventDefault();
	        $(e.target).find('input#email').css({
	            'border': 'solid 2px #217093',
	            'color': '#217093'
	        });
	        $(e.target).find('p#hint').html("");
	        window.rest.post('auth/reset-password', {
	                email: $(this).find('input#email').val()
	            })
	            .then(function (response) {
	                window.location = "/confirm";
	            })
	            .catch(function (error) {
	                $(e.target).find('input#email').css({
	                    'border': 'solid 2px #e7040f',
	                    'color': '#e7040f'
	                });
	                $(e.target).find('p#hint').html(error.message);
	            });
	    })
	
	
	    /////////////////////////
	    //COMPLETE REGISTRATION//
	    /////////////////////////
	
	    $("#completeLanguageSelect").find('select').change(function () {
	        console.log(this.options[this.selectedIndex].value)
	        window.localStorage.setItem("selectedNativeLanguage", this.options[this.selectedIndex].value);
	    });
	
	    $("form#completeRegistrationForm").submit(function (e) {
	        e.preventDefault();
	        $(e.target).find('input#password').css({
	            'border': 'solid 2px #217093',
	            'color': '#217093'
	        });
	        $(e.target).find('p#hint').html("");
	
	        var payload = {
	            password: $(this).find('input#password').val(),
	            token: window.rest.getParameterByName("token")
	        }
	
	        if (+window.localStorage.getItem("selectedNativeLanguage") ||
	        +window.localStorage.getItem("selectedNativeLanguage") === 0
	            ) {
	            payload["first_nlanguage"] = +window.localStorage.getItem("selectedNativeLanguage");
	        }
	
	        window.rest.post('users/confirm', payload)
	            .then(function (response) {
	                return window.localStorage.setItem("access_token", response.access_token);
	            })
	            .then(function () {
	                return window.rest.get("auth/current");
	            })
	            .then(function (response) {
	                window.localStorage.setItem("cached_user", JSON.stringify(response));
	                return response.id;
	            })
	            .then(function (response) {
	                // window.location = "/profile?id=" + response;
	                window.location = "/profile";
	                // window.location = "/teachers";
	            })
	            .catch(function (error) {
	                $(e.target).find('input#password').css({
	                    'border': 'solid 2px #e7040f',
	                    'color': '#e7040f'
	                });
	                $(e.target).find('p#hint').html(error.message);
	            });
	    })
	
	
	    /////////////////////////
	    /// ENTER NEW PASSWORD //
	    /////////////////////////
	
	    $("form#newPasswordForm").submit(function (e) {
	        e.preventDefault();
	        $(e.target).find('input#password').css({
	            'border': 'solid 2px #217093',
	            'color': '#217093'
	        });
	        $(e.target).find('p#hint').html("");
	        window.rest.post('auth/change-password', {
	                password: $(this).find('input#password').val(),
	                token: window.rest.getParameterByName("token")
	            })
	            .then(function (response) {
	                window.location = "/changed";
	            })
	            .catch(function (error) {
	                $(e.target).find('input#password').css({
	                    'border': 'solid 2px #e7040f',
	                    'color': '#e7040f'
	                });
	                $(e.target).find('p#hint').html(error.message);
	            });
	    })
	
	
	    /////////////////////////
	    //////    PROFILE ///////
	    /////////////////////////
	
	    $("form#profile_form").find('select').each(function (index, element) {
	        $(this).change(function (event) {
	            var where = $(element).data("putTo");
	            var what = $(element.options[element.selectedIndex]).data("value");
	            var payload = {};
	            payload[where] = what;
	            if (where === "compact") {
	                $('.dn_compact').each(function () {
	                    what ? $(this).hide() : $(this).show();
	                });
	            }
	
	            if (where === "first_llanguage") {
	                $('.llanguages_placeholder').each(function () {
	                    try {
	                        $(this).html($($(element.options[element.selectedIndex]).data("display"))[0].getAttribute("title"))
	                    } catch (e) {
	                        console.log(e)
	                    }
	                });
	            }
	
	            if (where === "first_llanguage" || where === "first_nlanguage") {
	                const selected_index = $(element.options[element.selectedIndex])[0].value;
	                if (selected_index == 0) {
	                    $("form#profile_form").find("#suggestions_" + where).removeClass("dn").addClass("flex");
	                } else {
	                    $("form#profile_form").find("#suggestions_" + where).removeClass("flex").addClass("dn");
	                }
	            }
	
	            if (where === "notificationFrequency") {
	                if (what === 0) {
	                    $('.notificationFrequency_status').each(function () {
	                        $(this).html("Inactive")
	                    })
	                    $('.notificationFrequency_description').each(function () {
	                        $(this).hide();
	                    })
	                } else {
	                    $('.notificationFrequency_status').each(function () {
	                        $(this).html("Active")
	                    })
	                    $('.notificationFrequency_description').each(function () {
	                        $(this).show();
	                    })
	                    $('.notificationFrequency_placeholder').each(function () {
	                        try {
	                            $(this).html($($(element.options[element.selectedIndex]).data("display"))[1].textContent.toLowerCase())
	                        } catch (e) {
	                            console.log(e)
	                        }
	                    });
	                }
	            }
	
	            window.rest.put(
	                'users/' + JSON.parse(window.localStorage.getItem("current_user"))["id"],
	                payload
	            ).then(function (user) {
	                window.localStorage.setItem("current_user", JSON.stringify(user));
	            }).catch(function (error) {
	                // Manage Exceptions
	            })
	        });
	    });
	
	    $("form#profile_form").find('textarea, input[type=text]').each(function (index, element) {
	        $(this).blur(function (event) {
	            try {
	                if (event.relatedTarget["id"] === $(element).attr("id") + "_save") {
	                    // console.log("clicked save")
	                } else {
	                    // console.log("clicked inside")
	                    $('#'+$(element).attr("id") + "_save").trigger( "click" );
	                    // $(element).val(JSON.parse(window.localStorage.getItem("current_user"))[$(element).attr("id")]);
	                }
	            } catch (e) {
	                // console.log("clicked outside")
	                $('#'+$(element).attr("id") + "_save").trigger( "click" );
	            }
	        });
	
	        $($(this.parentElement).find('input[type=button]')[0]).click(function (e) {
	            e.preventDefault();
	            console.log(element.value)
	
	            var what = element.value;
	            var payload = {};
	
	            if ($(element).attr("nested")) {
	                var key_first_level = $(element).attr("id").split("_")[0];
	                var key_second_level = $(element).attr("id").split("_")[1];
	                payload[key_first_level] = {};
	                payload[key_first_level][key_second_level] = what;
	            } else {
	                var key_first_level = $(element).attr("id");
	                payload[key_first_level] = what;
	            }
	
	            window.rest.put(
	                'users/' + JSON.parse(window.localStorage.getItem("current_user"))["id"],
	                payload
	            ).then(function (user) {
	                window.localStorage.setItem("current_user", JSON.stringify(user));
	                $(e.target).blur();
	            }).catch(function (error) {
	                // Manage Exceptions
	            })
	        });
	
	    })
	
	    $("form#profile_form").find('#visitProfileButton').click(function (e) {
	        e.preventDefault();
	        const publicProfileBase = (window.location.origin === "https://www.coffeestrap.com") ? window.location.origin : window.rest.defaults.baseURL;
	        try {
	            window.location = publicProfileBase + '/profiles/' + window.cs_ui.current_user.id;
	        } catch (e) {
	            window.location = publicProfileBase + '/profiles/' + JSON.parse(localStorage.getItem('current_user')).id;
	        }
	    });
	
	    // $("form#profile_form").find('#visitLessonsButton').click(function (e) {
	    //     e.preventDefault();
	    //     const publicProfileBase = (window.location.origin === "https://www.coffeestrap.com") ? window.location.origin : window.rest.defaults.baseURL;
	    //     window.location = publicProfileBase + '/learn/' + $(this).find("span.llanguages_placeholder").text();
	    // });
	
	    // $("header#profile_header").find('#visitLessonsButton').click(function (e) {
	    //     e.preventDefault();
	    //     const publicProfileBase = (window.location.origin === "https://www.coffeestrap.com") ? window.location.origin : window.rest.defaults.baseURL;
	    //     window.location = publicProfileBase + '/learn/' + $(this).find("span.llanguages_placeholder").text();
	    // });

/***/ })

/******/ });


// WEBPACK FOOTER //
// page_flow.js